interface ObjectWithId {
    id: number;
}

export const updateOrAddToList = <T extends ObjectWithId>(list: T[], newItem?: T) =>
    newItem ? [newItem, ...list.filter((item) => item.id !== newItem.id)] : list;
